export const environment = {
  production: true,
  local: false,
  firebase: {
    apiKey: "AIzaSyD0WKvYAB2OV2yIaRPHcv1hOAjilvXPjIY",
    authDomain: "deloitte.ai",
    projectId: "dcspcore"
  },
  homeUrl: 'dashboard',
  authParams: ['oidc.deloitte'],
  signInType: 'signInWithPopup',
  subscriptionServiceBaseURL: 'https://dcsp.api.deloitte.camp',
  subscriptionEndpoint: '/services/subscriptions',
  backendBaseURL: 'https://dcsp-dora.connect.api.deloitte.ai',
  product_id: 'prd_5a609b29-723f-4321-b6b5-d620e3f9bc3d',
  assetTitle: 'Dora',
  hideHeader: false,
  hideFooter: false,
  EXISTING_FILES_METADATA: undefined,
  CONFIDENTIAL_FILES_METADATA: undefined,
  CONFIDENTIAL_FILES_ALLOW_UNCLASSIFIED: true,
  locale: 'en-US'
};
